import { createActionThunk } from "redux-thunk-actions";
import {
  ADD_GREY_UPC_ITEM_NAME_FIELD,
  BARCODE_READ,
  BARCODE_READ_IMG,
  CLEAR_SYMPTOM,
  CREATE_SYMPTOM,
  DISMISS_SAVE_SUCCESS,
  GET_SYMPTOM_USERS,
  getEnded,
  getFailed,
  getStarted,
  getSucceeded,
  HISTORY_SUGGESTIONS_CLEAR,
  HISTORY_SUGGESTIONS_FAILED,
  HISTORY_SUGGESTIONS_STARTED,
  HISTORY_SUGGESTIONS_SUCCESS,
  INPUT_ADD_ITEM,
  ON_CHANGE_ALERT_STATUS,
  ON_CHANGE_SYMPTOMFORM,
  PARTIAL_RESULT_FOUND,
  RESET_CONTRIBUTE_ALERT_STATE,
  RESET_INPUT_PAGE,
  SAVE_FOOD_AND_SYMPTOMS,
  SEARCH_SYMPTOM_OPTIONS,
  SET_HHMM_MODE,
  SYMPTOM_CATEGORY_SELECTED,
  SYMPTOM_DATE_CHANGED,
  SYMPTOM_FROM_BODYMAP,
  SYMPTOM_KIT_ADD,
  SYMPTOM_KIT_SELECTED,
  SYMPTOM_OPTION_SELECTED,
  SYMPTOM_USER_SELECTED,
  SYMPTOMS_ITEM_DELETE,
  SYMPTOMS_ITEM_UPDATE,
  SYMPTOMS_ITEM_SELECT,
  UPDATE_ITEM_CANCELED,
} from "./constant";

import {
  createSymptom as createSymptomService,
  getCategories,
  saveFoodAndSymptoms,
  fetchRecentHistorySuggestions,
} from "../services/SymptomService";
import { getUser as getSymptomUsersService } from "../services/UserService";
import { submit } from "redux-form";
import {
  barcodeService,
  getPartialResult,
} from "../services/AutocompleteService";
import { getBarcode } from "../services/ContributeService";

const inputPageInitialization = (_id) => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(GET_SYMPTOM_USERS),
    });
    try {
      let users = await getSymptomUsersService(_id);
      let categories = await getCategories(_id);
      dispatch({
        type: getSucceeded(GET_SYMPTOM_USERS),
        payload: {
          users,
          categories,
        },
      });
    } catch (e) {
      dispatch({
        type: getFailed(GET_SYMPTOM_USERS),
      });
      alert(e);
    }
    let bodySymptom = {};
    bodySymptom = localStorage.getItem("bodyMapSymptom");
    if (bodySymptom) {
      dispatch({
        type: getStarted(SYMPTOM_FROM_BODYMAP),
      });

      dispatch({
        type: getSucceeded(SYMPTOM_FROM_BODYMAP),
      });
      if (bodySymptom !== "cancel") {
        bodySymptom = JSON.parse(bodySymptom);
        dispatch({
          type: SYMPTOM_OPTION_SELECTED,
          item: bodySymptom,
          bodyMap: true,
        });
      }
    } else {
      localStorage.removeItem("showList");
    }
    dispatch({
      type: getEnded(SYMPTOM_FROM_BODYMAP),
    });
  };
};
const createSymptom = createActionThunk(
  CREATE_SYMPTOM,
  (data, type, callback) => createSymptomService(data, type, callback)
);
const selectUser = (_id) => {
  return (dispatch) => {
    dispatch({
      type: SYMPTOM_USER_SELECTED,
      data: {
        _id: _id,
      },
    });
  };
};
const searchNameOptions = (
  val,
  type,
  crossClicked,
  contributeRedirectionAlert,
  time
) => {
  return (dispatch) => {
    dispatch({
      type: SEARCH_SYMPTOM_OPTIONS,
      val: val,
      crossClicked,
      contributeRedirectionAlert,
      time,
    });
  };
};
const onChangeSymptomForm = (e) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_SYMPTOMFORM,
      event: e,
    });
  };
};
const categorySelected = (e) => {
  return (dispatch) => {
    dispatch({
      type: SYMPTOM_CATEGORY_SELECTED,
      value: e.target.value,
    });
  };
};
const clearSymptom = (action) => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_SYMPTOM,
      action,
    });
  };
};
const onDateChange = (val) => {
  return (dispatch) => {
    dispatch({
      type: SYMPTOM_DATE_CHANGED,
      val: val,
    });
  };
};
const symptomOptionSelected = (data, opts) => {
  return async (dispatch) => {
    if (data.items) {
      dispatch({
        type: SYMPTOM_KIT_SELECTED,
        item: data,
      });
    } else {
      dispatch({
        type: SYMPTOM_OPTION_SELECTED,
        item: data,
        // Guard: never let HISTORY or normal typing set bodyMap
        bodyMap: !!(opts && opts.bodyMap === true),
      });
    }
  };
};
const addKitClicked = () => {
  return (dispatch) => {
    dispatch({
      type: SYMPTOM_KIT_ADD,
    });
  };
};

const saveClicked = (newData) => {
  return async (dispatch) => {
    dispatch({
      type: getStarted(SAVE_FOOD_AND_SYMPTOMS),
    });
    try {
      const data = await saveFoodAndSymptoms(newData);

      if (data && data.message) {
        throw { message: data.message, meta: data.meta };
      }
      
      dispatch({
        type: SAVE_FOOD_AND_SYMPTOMS,
        data: data,
      });
    } catch (e) {
      dispatch({
        type: getFailed(SAVE_FOOD_AND_SYMPTOMS),
        error: {
          message: typeof e === "string" ? e : (e && e.message),
          meta: (e && e.meta) || [],
        },
      });
    }
  };
};
const addItem = (item, displayName) => {
  return (dispatch) => {
    dispatch({
      type: INPUT_ADD_ITEM,
      item: item,
      displayName,
    });
  };
};
const selectItem = (user, vId) => {
  return (dispatch) => {
    dispatch({
      type: SYMPTOMS_ITEM_SELECT,
      vId: vId,
      user: user,
    });
  };
};
const deleteItem = (id) => {
  return (dispatch) => {
    dispatch({
      type: SYMPTOMS_ITEM_DELETE,
      vId: id,
    });
  };
};
const updateItem = (displayName) => {
  return (dispatch) => {
    dispatch({
      type: SYMPTOMS_ITEM_UPDATE,
      displayName,
    });
  };
};
const resetPage = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_INPUT_PAGE,
    });
  };
};
export const barcodeSearch = (val, cat, partial, preloadedData = null) => {
  return async (dispatch) => {
    let category = cat ? cat : "02";

    dispatch({
      type: getStarted(BARCODE_READ),
    });
    try {
      if (partial) {
        let data = preloadedData ? preloadedData : await barcodeService(val, cat);
        if (data.message) {
          alert(data.message);
        } else {
          data = data;
        }
        const needsMealDetail =
          ([cat].includes(data.category) &&
            (data.is_ref ||
              (!data.is_ref &&
                ((!data.is_own &&
                  !data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                  (data.is_own &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                  (data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt))))) ||
          (!data.is_ref &&
            ((!data.is_own &&
              data.is_history &&
              data.number_of_contribute >= 4 &&
              !data.show_prompt) ||
              (data.is_own &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt) ||
              (data.is_history &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt)));
        dispatch({
          type: getSucceeded(BARCODE_READ),
          data: data,
        });

        if (needsMealDetail) {
          dispatch({
            type: SYMPTOM_OPTION_SELECTED,
            item: data,
          });
        }
      } else {
        let data;
        let partialSearch = await getPartialResult(val, cat);
 
        if (partialSearch.length === 1 && partialSearch[0].upc === val) {
          data = await barcodeService(partialSearch[0].upc, cat);
          if (data.message) {
            alert(data.message);
          }

          const needsMealDetail =
            ((data.is_ref ||
              (!data.is_ref &&
                ((!data.is_own &&
                  !data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                  (data.is_own &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                  (data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt))))) ||
            (!data.is_ref &&
              ((!data.is_own &&
                data.is_history &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt) ||
                (data.is_own &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                (data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt)));

          dispatch({
            type: getSucceeded(BARCODE_READ),
            data: data,
            partialSearch,
          });

          if (needsMealDetail) {
            dispatch({
              type: SYMPTOM_OPTION_SELECTED,
              item: data,
            });
          }
        } else {
          if (partialSearch.length === 0) {
            dispatch({
              type: getFailed(PARTIAL_RESULT_FOUND),
              upc: val,
            });
          } else {
            dispatch({
              type: getSucceeded(PARTIAL_RESULT_FOUND),
              partialSearch,
            });
          }
        }
      }
    } catch (e) {
      dispatch({
        type: getFailed(BARCODE_READ),
        upc: val,
      });
      console.log(e);
    }
    dispatch({
      type: getEnded(BARCODE_READ),
    });
  };
};
const onSubmitUpcImage = (image, cat = "02") => {
  return async (dispatch) => {
    let category = cat;
    dispatch({
      type: getStarted(BARCODE_READ_IMG),
    });
    try {
      const barcodeNum = await getBarcode(image);
      dispatch({
        type: getSucceeded(BARCODE_READ_IMG),
        data: barcodeNum,
      });
      dispatch({
        type: getStarted(BARCODE_READ),
      });
      try {
        let data = await barcodeService(barcodeNum.barcode, cat);
        if (data.message) {
          alert(data.message);
        } else {
          data = data;
        }

        const needsMealDetail =
          ([cat].includes(data.category) &&
            (data.is_ref ||
              (!data.is_ref &&
                ((!data.is_own &&
                  !data.is_history &&
                  data.number_of_contribute >= 4 &&
                  !data.show_prompt) ||
                  (data.is_own &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt) ||
                  (data.is_history &&
                    data.number_of_contribute >= 4 &&
                    !data.show_prompt))))) ||
          (!data.is_ref &&
            ((!data.is_own &&
              data.is_history &&
              data.number_of_contribute >= 4 &&
              !data.show_prompt) ||
              (data.is_own &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt) ||
              (data.is_history &&
                data.number_of_contribute >= 4 &&
                !data.show_prompt)));
          // (!data.is_history &&
          //   !data.is_own &&
          //   data.number_of_contribute >= 4 &&
          //   !data.show_prompt);
        dispatch({
          type: getSucceeded(BARCODE_READ),
          data: data,
        });
        if (needsMealDetail) {
          dispatch({
            type: SYMPTOM_OPTION_SELECTED,
            item: data,
          });
        }
      } catch (e) {
        dispatch({
          type: getFailed(BARCODE_READ),
          upc: barcodeNum.barcode,
          message: e.message && e.message === "" ? "" : false,
        });
      }
      dispatch({
        type: getEnded(BARCODE_READ),
      });
    } catch (error) {
      dispatch({
        type: getFailed(BARCODE_READ_IMG),
        date: error,
      });
    }
  };
};
const updateItemCanceled = (user, vId) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ITEM_CANCELED,
      user,
      vId,
    });
  };
};
const onChangeAlertStatus = (item) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ON_CHANGE_ALERT_STATUS,
        data: item,
      });
    } catch (error) {}
  };
};
const addGreyUPCToItemNameField = (barcode) => ({
  type: ADD_GREY_UPC_ITEM_NAME_FIELD,
  payload: barcode,
});
const setHHMMMode = (value) => ({
  type: SET_HHMM_MODE,
  value,
});
const resetContributeAlertState = () => ({
  type: RESET_CONTRIBUTE_ALERT_STATE,
});

const fetchRecentNames = () => {
  return async (dispatch, getState) => {
    const { symptom } = getState(); // or your reducer key
    const category     = symptom && symptom.symptomForm && symptom.symptomForm.category;           // "01".."07"
    const participants = (symptom && symptom.symptomForm && symptom.symptomForm.users) || [];        // array
    if (!category || !participants.length) {
      return; // nothing to do
    }

    dispatch({ type: HISTORY_SUGGESTIONS_STARTED });

    try {
      const payload = await fetchRecentHistorySuggestions(category, participants, undefined, undefined);

      // Shape matches your existing autocomplete structure:
      // - nameOptions ← array of strings to show
      // - nameTotalOptions ← array of {fullname,name,...}
      dispatch({
        type: HISTORY_SUGGESTIONS_SUCCESS,
        payload
      });
    } catch (e) {
      dispatch({ type: HISTORY_SUGGESTIONS_FAILED, error: String(e) });
    }
  };
};

const clearHistorySuggestions = () => ({
  type: HISTORY_SUGGESTIONS_CLEAR,
});
const dismissSaveSuccess = () => ({ type: DISMISS_SAVE_SUCCESS });

export default {
  inputPageInitialization,
  selectUser,
  categorySelected,
  clearSymptom,
  searchNameOptions,
  onDateChange,
  symptomOptionSelected,
  selectItem,
  createSymptom,
  addItem,
  onChangeSymptomForm,
  saveClicked,
  deleteItem,
  updateItem,
  resetPage,
  addKitClicked,
  barcodeSearch,
  onSubmitUpcImage,
  updateItemCanceled,
  onChangeAlertStatus,
  addGreyUPCToItemNameField,
  setHHMMMode,
  resetContributeAlertState,
  fetchRecentNames,
  clearHistorySuggestions,
  dismissSaveSuccess,
};



// WEBPACK FOOTER //
// ./src/actions/symptomActions.js